/* JiraNlToJqlCard.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./JiraNlToJqlCard.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { cx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { useAIEventsInstrumentation } from '@atlassian/ai-analytics';
import { AnimatedWrapper } from '@atlassian/ai-common';
import { onJiraNlToJqlCardLoaded, onJiraViewAllButtonClicked, onNonGenerativeAIAnswerResultShown, SmartLinksAnalyticsContextLocation } from '../../../../ai-answer-dialog/analytics';
import { logger, useAnalytics } from '../../../../common';
import { SainAction, useSAINUsageCriteriaMet } from '../../../../common/controller/analytics';
import { AnswerCardType } from '../../../../constants';
import { onNonGenerativeKnowledgeCardLinkClick } from '../../../../knowledge-cards/analytics';
import { sha256Hash } from '../../../../utils';
import { AIDisclaimerAndFeedback } from '../../../common/ui/ai-disclaimer-and-feedback';
import { SmartAnswerCardBodyGenerating } from '../../../common/ui/smart-answer-card-body-generating';
import { useIssueSearchQuery } from '../../api/useIssueSearchQuery/useIssueSearchQuery';
import { useNaturalLanguageToJqlQuery } from '../../api/useNaturalLanguageToJqlQuery/useNaturalLanguageToJqlQuery';
import { ErrorCard } from './ErrorCard';
import { IssueTable } from './IssueTable';
import { messages } from './messages';
import { ViewAllButton } from './ViewAllButton';
var styles = {
  container: "_2rko12b0 _19itia51",
  tableContainer: "_2rko1mok _kqswh2mm _18u0pxbi _2hwxpxbi _otyru2gc",
  sidePadding: "_19bvpxbi _u5f3pxbi",
  headerContainer: "_ca0qutpp _u5f3pxbi _n3tdu2gc",
  footer: "_18zrpxbi _85i5utpp",
  viewAllContainer: "_ca0q1b66 _n3td1b66 _y3gn1e5h"
};
var buildJiraLink = function buildJiraLink(_ref) {
  var issueUrl = _ref.issueUrl,
    jql = _ref.jql;
  var hostname = new URL(issueUrl).hostname;
  var jiraLink = new URL("https://".concat(hostname, "/issues/"));
  jiraLink.searchParams.append('jql', jql);
  return jiraLink.toString();
};
export var JiraNlToJqlCard = /*#__PURE__*/memo(function (props) {
  var renderStartTime = useRef(performance.now());
  var analyticsFiredRef = useRef(false);
  var query = props.query,
    title = props.title,
    cloudId = props.cloudId,
    aiBrand = props.aiBrand,
    searchSessionId = props.searchSessionId,
    workspaceId = props.workspaceId,
    product = props.product,
    onFMPReached = props.onFMPReached;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    issueUrl = _useState2[0],
    setIssueUrl = _useState2[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useAIEventsInstrumen = useAIEventsInstrumentation(),
    trackAIInteractionInit = _useAIEventsInstrumen.trackAIInteractionInit;
  var _useNaturalLanguageTo = useNaturalLanguageToJqlQuery({
      cloudId: cloudId,
      query: query,
      workspaceId: workspaceId,
      product: product
    }),
    jqlLoading = _useNaturalLanguageTo.loading,
    jqlError = _useNaturalLanguageTo.error,
    jql = _useNaturalLanguageTo.jql;
  var _useIssueSearchQuery = useIssueSearchQuery({
      cloudId: cloudId,
      jql: jql,
      workspaceId: workspaceId,
      product: product
    }),
    issues = _useIssueSearchQuery.issues,
    totalIssuesCount = _useIssueSearchQuery.totalIssuesCount,
    issuesLoading = _useIssueSearchQuery.loading,
    issuesError = _useIssueSearchQuery.error;
  var analyticsAttributes = useMemo(function () {
    return {
      searchSessionId: searchSessionId,
      queryHash: sha256Hash(query),
      brand: aiBrand,
      source: 'jira_nl_2_jql_card',
      query: query,
      answerString: jql || '',
      answerCardType: AnswerCardType.JIRA_NATURAL_LANGUAGE_QUERY
    };
  }, [searchSessionId, query, aiBrand, jql]);
  var fireJiraNlToJqlCardLoaded = useCallback(function (_ref2) {
    var success = _ref2.success,
      endState = _ref2.endState;
    var apiLoadedTime = performance.now();
    var totalDuration = apiLoadedTime - renderStartTime.current;
    fireAnalyticsEvent(onJiraNlToJqlCardLoaded(_objectSpread(_objectSpread({}, analyticsAttributes), {}, {
      success: success,
      loadTime: totalDuration,
      endState: endState
    })));
  }, [fireAnalyticsEvent, analyticsAttributes]);

  // using the first issue's webUrl to build a jira url for the view all 'x' items button
  useEffect(function () {
    if (!issuesLoading && !issuesError && issues !== null && issues !== void 0 && issues.length && issues[0]) {
      try {
        var firstIssueUrl = issues[0].node.webUrl;
        setIssueUrl(buildJiraLink({
          issueUrl: firstIssueUrl || '',
          jql: jql || ''
        }));
      } catch (error) {
        logger.error({
          error: error,
          functionName: 'JiraNlToJqlCard'
        });
      }
    }
  }, [issuesLoading, issuesError, issues, jql]);
  useEffect(function () {
    trackAIInteractionInit();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  // fire Analytics Events on final state changes
  useEffect(function () {
    if (fg('kd_jqlcard_additional_error_handling')) {
      if (analyticsFiredRef.current) {
        return;
      }
      if (!jqlLoading && !jqlError && !issuesLoading && !issuesError && issues !== null && issues !== void 0 && issues.length && issues[0]) {
        /*
        Success block
        */
        analyticsFiredRef.current = true;
        onFMPReached();
        fireJiraNlToJqlCardLoaded({
          success: true,
          endState: 'answered'
        });
        fireAnalyticsEvent(onNonGenerativeAIAnswerResultShown(analyticsAttributes));
        fireSAINUsageEvent({});
      } else if (!jqlLoading && jqlError) {
        /*
         * * JQL error block
         */
        analyticsFiredRef.current = true;
        fireJiraNlToJqlCardLoaded({
          success: false,
          endState: 'jql-error'
        });
      } else if (!issuesLoading && issuesError) {
        /*
         * * Issues error block
         */
        analyticsFiredRef.current = true;
        fireJiraNlToJqlCardLoaded({
          success: false,
          endState: 'issues-error'
        });
      } else if (!jqlLoading && !issuesLoading && (issues === null || issues === void 0 ? void 0 : issues.length) === 0) {
        /*
         * * No issues block,
         * * while is is not an error, we're still marking it as a failure cause the user sees an error card
         */
        analyticsFiredRef.current = true;
        fireJiraNlToJqlCardLoaded({
          success: false,
          endState: 'no-issues'
        });
      }
    } else {
      if (!jqlLoading && !issuesLoading && !issuesError && issues !== null && issues !== void 0 && issues.length && issues[0]) {
        onFMPReached();
        fireJiraNlToJqlCardLoaded({
          success: true,
          endState: 'answered'
        });
        fireAnalyticsEvent(onNonGenerativeAIAnswerResultShown(analyticsAttributes));
        fireSAINUsageEvent({});
      }
    }
  }, [jqlLoading, issuesLoading, issuesError, jqlError, issues, onFMPReached, fireJiraNlToJqlCardLoaded, fireAnalyticsEvent, fireSAINUsageEvent, analyticsAttributes]);
  var onContainerClick = function onContainerClick(event) {
    var targetMarker = event.target.dataset['testid'];
    fireAnalyticsEvent(onNonGenerativeKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, analyticsAttributes), {}, {
      targetMarker: targetMarker
    })));
    fireSAINUsageEvent({
      metCriteria: SainAction.JIRA_NL_TO_JQL_CLICKED
    });
  };
  var onViewAllButtonClicked = function onViewAllButtonClicked() {
    fireAnalyticsEvent(onJiraViewAllButtonClicked(_objectSpread(_objectSpread({}, analyticsAttributes), {}, {
      totalIssuesCount: totalIssuesCount || 0
    })));
  };
  if (jqlLoading || issuesLoading) {
    return /*#__PURE__*/React.createElement(AnimatedWrapper, null, /*#__PURE__*/React.createElement(SmartAnswerCardBodyGenerating, {
      heightOverride: "jiraNlToJqlCard"
    }));
  }
  if (jqlError || issuesError || (issues === null || issues === void 0 ? void 0 : issues.length) === 0) {
    // new error instrumentation is handled in the useEffect above
    if (!fg('kd_jqlcard_additional_error_handling')) {
      fireJiraNlToJqlCardLoaded({
        success: false
      });
    }
    return /*#__PURE__*/React.createElement(ErrorCard, {
      query: query
    });
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.container,
    testId: "jira-nl-to-jql-card-wrapper"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.headerContainer, styles.sidePadding)
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "xsmall"
  }, title || formatMessage(messages.cardTitle))), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.tableContainer,
    onClick: onContainerClick
  }, /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      attributes: _objectSpread({
        location: SmartLinksAnalyticsContextLocation.SAIN_JIRA_NL_TO_JQL_CARD
      }, analyticsAttributes),
      location: SmartLinksAnalyticsContextLocation.SAIN_JIRA_NL_TO_JQL_CARD
    }
  }, /*#__PURE__*/React.createElement(SmartCardProvider, null, /*#__PURE__*/React.createElement(IssueTable, {
    issues: issues || [],
    analyticsAttributes: analyticsAttributes
  })))), totalIssuesCount && totalIssuesCount > 0 && issueUrl ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.viewAllContainer, styles.sidePadding)
  }, /*#__PURE__*/React.createElement(ViewAllButton, {
    totalIssuesCount: totalIssuesCount,
    url: issueUrl,
    callback: onViewAllButtonClicked
  })) : null, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.footer
  }, /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
    showFeedbackButtons: true
  })));
});